import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutModule } from '../../../../../@config/layout/layout.module';
import { CustomLayoutComponent } from './custom-layout.component';
import { SidenavModule } from '../../../../../@config/layout/sidenav/sidenav.module';
import { ToolbarModule } from '../../../../../@config/layout/toolbar/toolbar.module';
import { FooterModule } from '../../../../../@config/layout/footer/footer.module';
import { ConfigPanelModule } from '../../../../../@config/components/config-panel/config-panel.module';
import { SidebarModule } from '../../../../../@config/components/sidebar/sidebar.module';
import { QuickpanelModule } from '../../../../../@config/layout/quickpanel/quickpanel.module';


@NgModule({
  declarations: [CustomLayoutComponent],
  imports: [
    CommonModule,
    LayoutModule,
    SidenavModule,
    ToolbarModule,
    FooterModule,
    ConfigPanelModule,
    SidebarModule,
    QuickpanelModule
  ]
})
export class CustomLayoutModule {
}
